import { create } from "zustand";

// ----------------------------------------------------------------------------
// Cockpit-wide UI state. Server data lives in React Query; this store is just
// what's selected, what's open, and what time the last refresh happened.
// ----------------------------------------------------------------------------

export type DrawerKind = "task" | "approval" | "service" | "note" | null;

interface DrawerPayload {
  kind: DrawerKind;
  id: string | null;
}

interface CockpitState {
  selectedProjectId: string | null;
  setSelectedProjectId: (id: string | null) => void;

  drawer: DrawerPayload;
  openDrawer: (kind: Exclude<DrawerKind, null>, id: string) => void;
  closeDrawer: () => void;

  paletteOpen: boolean;
  setPaletteOpen: (open: boolean) => void;

  helpOpen: boolean;
  setHelpOpen: (open: boolean) => void;

  refreshTimestamp: number;
  bumpRefresh: () => void;
}

export const useCockpit = create<CockpitState>((set) => ({
  selectedProjectId: null,
  setSelectedProjectId: (id) => set({ selectedProjectId: id }),

  drawer: { kind: null, id: null },
  openDrawer: (kind, id) => set({ drawer: { kind, id } }),
  closeDrawer: () => set({ drawer: { kind: null, id: null } }),

  paletteOpen: false,
  setPaletteOpen: (paletteOpen) => set({ paletteOpen }),

  helpOpen: false,
  setHelpOpen: (helpOpen) => set({ helpOpen }),

  refreshTimestamp: Date.now(),
  bumpRefresh: () => set({ refreshTimestamp: Date.now() }),
}));
